import createFavoriteAssetsAnalyticsPlugin from './analytics.js'
import createFavoriteAssetsLifecyclePlugin from './lifecycle.js'

export const favoriteAssetsLifecyclePluginDefinition = {
  id: 'favoriteAssetsLifecyclePlugin',
  type: 'plugin',
  factory: createFavoriteAssetsLifecyclePlugin,
  dependencies: ['favoriteAssetsAtom', 'port'],
  public: true,
}

export const favoriteAssetsAnalyticsPluginDefinition = {
  id: 'favoriteAssetsAnalyticsPlugin',
  type: 'plugin',
  factory: createFavoriteAssetsAnalyticsPlugin,
  dependencies: ['analytics', 'favoriteAssetsAtom'],
  public: true,
}
